import axiosInstance from './axiosInstance';

export interface RecommendedTimeline {
  id: number;
  topic_area_id: number;
  status: 'pending' | 'approved' | 'rejected';
  requested_by: number;
  approved_by: number | null;
  requested_at: string;
  approved_at: string | null;
  display_order: number;
  title: string;
  summary: string;
  requester_name?: string;
}

export async function requestRecommend(topicAreaId: number): Promise<void> {
  await axiosInstance.post('/api/recommend/request', { topicAreaId });
}

export async function getRecommends(): Promise<RecommendedTimeline[]> {
  const res = await axiosInstance.get('/api/recommend');
  return res.data;
}

export async function getPendingRecommends(): Promise<RecommendedTimeline[]> {
  const res = await axiosInstance.get('/api/recommend/pending');
  return res.data;
}

export async function approveRecommend(id: number): Promise<void> {
  await axiosInstance.put(`/api/recommend/${id}/approve`);
}

export async function rejectRecommend(id: number): Promise<void> {
  await axiosInstance.put(`/api/recommend/${id}/reject`);
}
